// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-root {
  position: fixed;
  inset: 0;
  z-index: 10050;
  pointer-events: none;
}

.onboarding-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  pointer-events: auto;
}

.onboarding-spotlight {
  position: fixed;
  z-index: 10051;
  border-radius: 8px;
  box-shadow: 0 0 0 9999px rgba(15, 23, 42, 0.55);
  pointer-events: none;
  transition: top 0.2s ease, left 0.2s ease, width 0.2s ease, height 0.2s ease;
  outline: 2px solid #4f46e5;
  outline-offset: 2px;
}

.onboarding-tooltip {
  position: fixed;
  z-index: 10052;
  max-width: min(22rem, calc(100vw - 2rem));
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.22);
  padding: 1rem 1.1rem;
  pointer-events: auto;
}

.onboarding-tooltip h3 {
  margin: 0 0 0.5rem;
  font-size: 1.05rem;
}

.onboarding-tooltip p {
  margin: 0 0 0.75rem;
  font-size: 0.92rem;
  line-height: 1.45;
  color: #334155;
}

.onboarding-tooltip-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  justify-content: space-between;
}

.onboarding-progress {
  font-size: 0.8rem;
  color: #64748b;
}

.onboarding-actions {
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
}

.onboarding-arrow {
  position: fixed;
  z-index: 10052;
  width: 0;
  height: 0;
  pointer-events: none;
}

.onboarding-arrow--top {
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #fff;
}

.onboarding-arrow--bottom {
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #fff;
}

.onboarding-arrow--left {
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #fff;
}

.onboarding-arrow--right {
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid #fff;
}

.onboarding-offer-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10040;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.onboarding-offer-card {
  background: #fff;
  border-radius: 12px;
  max-width: 28rem;
  width: 100%;
  padding: 1.5rem;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
}

.onboarding-offer-card h2 {
  margin: 0 0 0.5rem;
  font-size: 1.25rem;
}

.onboarding-offer-card p {
  margin: 0 0 1rem;
  color: #475569;
  line-height: 1.5;
}

.onboarding-offer-lang {
  display: inline-flex;
  border: 1px solid #dde1e6;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 1rem;
}

.onboarding-offer-lang button {
  border: none;
  background: #fff;
  padding: 0.3rem 0.65rem;
  font-size: 0.85rem;
  cursor: pointer;
  color: #64748b;
}

.onboarding-offer-lang button.is-active {
  background: #0d6efd;
  color: #fff;
  font-weight: 600;
}

.onboarding-offer-actions {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  align-items: center;
}

.onboarding-offer-disable {
  margin-left: auto;
  font-size: 0.88rem;
}

.onboarding-help-btn {
  font-size: 0.85rem;
  padding: 0.25rem 0.55rem;
  min-width: auto;
}

.onboarding-toast {
  position: fixed;
  bottom: 1.25rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10060;
  background: #1e293b;
  color: #f8fafc;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  gap: 1rem;
  max-width: min(24rem, calc(100vw - 2rem));
  pointer-events: auto;
}

.onboarding-toast p {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.4;
}

.onboarding-toast .btn-link {
  color: #93c5fd;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/onboarding/onboarding.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,+CAA+C;EAC/C,oBAAoB;EACpB,4EAA4E;EAC5E,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,QAAQ;EACR,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".onboarding-root {\n  position: fixed;\n  inset: 0;\n  z-index: 10050;\n  pointer-events: none;\n}\n\n.onboarding-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  pointer-events: auto;\n}\n\n.onboarding-spotlight {\n  position: fixed;\n  z-index: 10051;\n  border-radius: 8px;\n  box-shadow: 0 0 0 9999px rgba(15, 23, 42, 0.55);\n  pointer-events: none;\n  transition: top 0.2s ease, left 0.2s ease, width 0.2s ease, height 0.2s ease;\n  outline: 2px solid #4f46e5;\n  outline-offset: 2px;\n}\n\n.onboarding-tooltip {\n  position: fixed;\n  z-index: 10052;\n  max-width: min(22rem, calc(100vw - 2rem));\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.22);\n  padding: 1rem 1.1rem;\n  pointer-events: auto;\n}\n\n.onboarding-tooltip h3 {\n  margin: 0 0 0.5rem;\n  font-size: 1.05rem;\n}\n\n.onboarding-tooltip p {\n  margin: 0 0 0.75rem;\n  font-size: 0.92rem;\n  line-height: 1.45;\n  color: #334155;\n}\n\n.onboarding-tooltip-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n  justify-content: space-between;\n}\n\n.onboarding-progress {\n  font-size: 0.8rem;\n  color: #64748b;\n}\n\n.onboarding-actions {\n  display: flex;\n  gap: 0.4rem;\n  flex-wrap: wrap;\n}\n\n.onboarding-arrow {\n  position: fixed;\n  z-index: 10052;\n  width: 0;\n  height: 0;\n  pointer-events: none;\n}\n\n.onboarding-arrow--top {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-bottom: 10px solid #fff;\n}\n\n.onboarding-arrow--bottom {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-top: 10px solid #fff;\n}\n\n.onboarding-arrow--left {\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-right: 10px solid #fff;\n}\n\n.onboarding-arrow--right {\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-left: 10px solid #fff;\n}\n\n.onboarding-offer-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 10040;\n  background: rgba(15, 23, 42, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.onboarding-offer-card {\n  background: #fff;\n  border-radius: 12px;\n  max-width: 28rem;\n  width: 100%;\n  padding: 1.5rem;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);\n}\n\n.onboarding-offer-card h2 {\n  margin: 0 0 0.5rem;\n  font-size: 1.25rem;\n}\n\n.onboarding-offer-card p {\n  margin: 0 0 1rem;\n  color: #475569;\n  line-height: 1.5;\n}\n\n.onboarding-offer-lang {\n  display: inline-flex;\n  border: 1px solid #dde1e6;\n  border-radius: 6px;\n  overflow: hidden;\n  margin-bottom: 1rem;\n}\n\n.onboarding-offer-lang button {\n  border: none;\n  background: #fff;\n  padding: 0.3rem 0.65rem;\n  font-size: 0.85rem;\n  cursor: pointer;\n  color: #64748b;\n}\n\n.onboarding-offer-lang button.is-active {\n  background: #0d6efd;\n  color: #fff;\n  font-weight: 600;\n}\n\n.onboarding-offer-actions {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.onboarding-offer-disable {\n  margin-left: auto;\n  font-size: 0.88rem;\n}\n\n.onboarding-help-btn {\n  font-size: 0.85rem;\n  padding: 0.25rem 0.55rem;\n  min-width: auto;\n}\n\n.onboarding-toast {\n  position: fixed;\n  bottom: 1.25rem;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10060;\n  background: #1e293b;\n  color: #f8fafc;\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  max-width: min(24rem, calc(100vw - 2rem));\n  pointer-events: auto;\n}\n\n.onboarding-toast p {\n  margin: 0;\n  font-size: 0.9rem;\n  line-height: 1.4;\n}\n\n.onboarding-toast .btn-link {\n  color: #93c5fd;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
